// src/router/index.js
import { createRouter, createWebHistory } from 'vue-router';
import Home from '../views/Home/index.vue';
import Node from '../views/Node/index.vue';
import Serve from '../views/Serve/index.vue';
import Open from '../views/Open/index.vue';
import About from '../views/About/index.vue';
import MID from '../views/MID/index.vue';
import News from '../views/News/index.vue';
import NewsDetail from '../views/NewsDetail/index.vue';

// 获取环境变量中的 BASE_URL
const baseUrl = process.env.BASE_URL || '/';

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/Node',
    name: 'Node',
    component: Node
  },
  {
    path: '/News/:id(\\d+)',
    name: 'News',
    component: News
  },
  {
    path: '/NewsDetail/:id(\\d+)',
    name: 'NewsDetail',
    component: NewsDetail
  },
  {
    path: '/Serve',
    name: 'Serve',
    component: Serve
  },
  {
    path: '/Open',
    name: 'Open',
    component: Open
  },
  {
    path: '/About',
    name: 'About',
    component: About
  },
  {
    path: '/MID',
    name: 'MID',
    component: MID
  }
];

const router = createRouter({
  history: createWebHistory(baseUrl),
  routes
});

export default router;